import React, {Component} from "react";
import { Input, Button, Select, Modal, DatePicker, Checkbox, Row, Col } from 'antd';
import { Form } from '@ant-design/compatible';
import {bindActionCreators} from "redux";
import * as RoomPlanActions from "../../redux/RoomPlan/actions";
import connect from "react-redux/es/connect/connect";
import moment from 'moment';
import {DeleteOutlined, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import HouseImage from './HouseImage.svg';
import RoomImage from './RoomImage.svg';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
    },
};

const formItemLayoutWithOutLabel = {
    wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 18, offset: 6 },
    },
};

const ulstyle = {
    listStyle: 'none',
    padding: '0px'
};




let uuid = 0;

const HouseTypes = [
    "Internet",
    "Automat",
    "Sanitär",
    "Beleuchtung",
    "Rezeption",
    "Parkplatz",
    "Türe",
    "Büro",
    "Dach",
    "WC",
    "Elektrik",
];

const RoomTypes = [
    "TV",
    "Tisch",
    "Kleiner Schank mit Safe",
    "Deckenlampe",
    "Stuhl",
    "Sideboard",
    "Tischleuchte",
    "Schrank",
    "Dusche",
    "Waschbecken",
];


class Todos extends Component {


    componentWillMount() {
        this.props.actions.loadHouses();
    }



    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const valuesToSave = {...values, todos: (values.todos || []).map(todo => {
                    if(todo.type === "Sonstiges") {
                        todo.type = todo.sonstiges;
                    }
                    return todo;
                    })}
                this.props.actions.saveTodo(valuesToSave, this.props.actTodoID);
            }
        });
    };

    handleCancel = () => {
        this.props.actions.showTodo(false);
    };



    componentWillReceiveProps(nextProps) {


        if(this.props.TodoVisible && !nextProps.TodoVisible) {
            this.props.actions.clearTodo();
            this.props.form.resetFields();
        } else if(!this.props.TodoVisible && nextProps.TodoVisible) {
            uuid = 0;
            if(nextProps.actTodoID) {
                //alert("loading reservation");
                this.props.actions.loadTodo(nextProps.actTodoID);
            }



        }

        if(nextProps.TodoVisible) {
            //TO Set House and Room correctly - e.g. Price & Rooms for correct House
            if(this.props.Todo.house !== nextProps.Todo.house) {
                this.props.actions.changeHouse(nextProps.Todo.house);
            }
           /*if(this.props.Todo.room !== nextProps.Todo.room) {
                this.props.actions.changeRoom(nextProps.Todo.room);
            }*/
        }


        /*if(this.props.workflowList.length > uuid) {
            uuid = this.props.workflowList.length;
        }*/
    }


    removeToDo = (k) => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        form.setFieldsValue({
            keys: keys.filter(key => key !== k),
        });
    };

    addToDo = () => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(uuid);
        uuid++;

        form.setFieldsValue({
            keys: nextKeys,
        });
    };



    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        //getFieldDecorator('keys', { initialValue: this.props.workflowList.map((c, i) => {return i;}) });

        //getFieldDecorator('keys', { initialValue: this.props.workflowList.map((c, i) => {return i;}) });
        getFieldDecorator('keys', { initialValue: this.props.Todo.todos ? this.props.Todo.todos.map((c, i) => {return i;} ) : []} );
        const keys = getFieldValue('keys');

        if(this.props.Todo.todos && uuid < this.props.Todo.todos.length) { uuid = this.props.Todo.todos.length; }



        let formItems = keys.map((k, index) => {

            let actType = this.props.Todo.todos ? this.props.Todo.todos[k] ? this.props.Todo.todos[k].type : "" : "";
            if(actType.length > 0 && ![...HouseTypes, ...RoomTypes].find(type => type === actType)) {
                actType = "Sonstiges";
            }

            return (
                <Row gutter={10}>
                    <Col span={4}>
                    </Col>
                    <Col span={2}>
                        <FormItem
                            {...formItemLayoutWithOutLabel}
                            label={''}
                            required={false}
                            key={k+'C'}
                        >
                            {getFieldDecorator(`todos[${k}].done`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                initialValue: this.props.Todo.todos ? this.props.Todo.todos[k] ? this.props.Todo.todos[k].done : false : false,
                                valuePropName: 'checked',
                            })(
                                <Checkbox />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={7}>
                        <FormItem
                            label={''}
                            required={false}
                            key={k}
                        >
                            {getFieldDecorator(`todos[${k}].type`, {
                                initialValue: actType,
                                rules: [{
                                    required: true,
                                    whitespace: true,
                                    message: "Bitte geben Sie eine Aufgabe ein, oder entfernen Sie dieses Feld",
                                }],
                            })(
                                <Select
                                    getPopupContainer={trigger => trigger.parentNode}
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Wählen Sie eine Art"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {!this.props.actTodoIsRoom ?
                                        HouseTypes.map(type => <Option key={type} value={type}>{type}</Option>)
                                    :
                                        RoomTypes.map(type => <Option key={type} value={type}>{type}</Option>)
                                    }
                                    <Option value={"Sonstiges"}>Sonstiges</Option>
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={6}>
                        {getFieldValue(`todos[${k}].type`) === "Sonstiges" ? <FormItem
                            label={''}
                            required={false}
                            key={k}
                        >
                            {getFieldDecorator(`todos[${k}].sonstiges`, {
                                initialValue: this.props.Todo.todos ? this.props.Todo.todos[k] ? this.props.Todo.todos[k].type : "" : "",
                                rules: [{
                                    required: true,
                                    whitespace: true,
                                    message: "Bitte geben Sie eine Aufgabe ein, oder entfernen Sie dieses Feld",
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>: <></>}
                    </Col>
                    <Col span={4}>
                        <MinusCircleOutlined
                            className="dynamic-delete-button"
                            style={{marginTop: '11px'}}
                            onClick={() => this.removeToDo(k)}
                        />
                    </Col>

                    <Col span={6}>&nbsp;</Col>
                    <Col span={13}>
                        <FormItem
                            label={''}
                            required={false}
                            key={k+"schedule"}
                        >
                            {getFieldDecorator(`todos[${k}].schedule`, {
                                initialValue: this.props.Todo.todos ? this.props.Todo.todos[k] ? this.props.Todo.todos[k].schedule : null : null,
                                rules: [{
                                    required: false,
                                }],
                            })(
                                <Select
                                    getPopupContainer={trigger => trigger.parentNode}
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Wählen Sie eine Art"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value={null}>Nicht wiederholen</Option>
                                    <Option value={"daily"}>Täglich wiederholen</Option>
                                    <Option value={"weekly"}>Wöchentlich wiederholen</Option>
                                    <Option value={"monthly"}>Monatlich wiederholen</Option>
                                    <Option value={"yearly"}>Jährlich wiederholen</Option>
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={4}>&nbsp;</Col>

                    <Col span={6}>&nbsp;</Col>
                    <Col span={13} >
                        <FormItem
                            label={''}
                            required={false}
                            key={k}
                        >
                            {getFieldDecorator(`todos[${k}].job`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                initialValue: this.props.Todo.todos ? this.props.Todo.todos[k] ? this.props.Todo.todos[k].job : "" : "",
                                rules: [{
                                    required: true,
                                    whitespace: true,
                                    message: "Bitte geben Sie eine Aufgabe ein, oder entfernen Sie dieses Feld",
                                }],
                            })(
                                <Input placeholder="Aufgabe eingeben" style={{ width: '100%', marginRight: 8 }} />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={4}>&nbsp;</Col>
                </Row>
            );
        });

        return (
                <Modal
                    title="Aufgaben"
                    open={this.props.TodoVisible}
                    onOk={this.handleSubmit}
                    onCancel={this.handleCancel}
                    width={"80%"}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>Abbrechen</Button>,
                        <Button key="submit" type="primary" onClick={this.handleSubmit}>Speichern</Button>
                    ]}
                >
                    <Row>
                        <Col span={24}>
                            <img src={!!this.props.actTodoIsRoom ? RoomImage : HouseImage} width={"100%"} />
                        </Col>
                        <Col span={24}>
                            &nbsp;
                        </Col>
                        <Col span={24}>
                            <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
                                <FormItem
                                    {...formItemLayout}
                                    label={"Haus"}
                                    key={'house'}
                                >
                                    {getFieldDecorator('house', {
                                        initialValue: this.props.Todo.house,
                                        rules: [{
                                            required: true,
                                            whitespace: true,
                                            message: "Bitte wählen Sie ein Haus aus."
                                        }],
                                    })(
                                        <Select
                                            disabled={true}
                                            showSearch
                                            style={{ width: 400 }}
                                            placeholder="Wählen Sie ein Haus"
                                            optionFilterProp="children"
                                            onChange={(val) => this.props.actions.changeHouse(val)}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {this.props.Houses.map(house => <Option key={house.name} value={house.name}>{house.name}</Option>)}
                                        </Select>
                                    )}
                                </FormItem>

                                {/*!!this.props.Todo.Room ?
                                    <FormItem
                                        {...formItemLayout}
                                        label={"Zimmer"}
                                        required={true}
                                        key={'room'}
                                    >
                                        {getFieldDecorator('room', {
                                            initialValue: this.props.Todo.room,
                                            rules: [{
                                                required: true,
                                                whitespace: true,
                                                message: "Bitte wählen Sie ein Zimmer aus."
                                            }],
                                        })(
                                            <Select
                                                disabled={true}
                                                showSearch
                                                style={{ width: 400 }}
                                                placeholder="Wählen Sie ein Zimmer"
                                                optionFilterProp="children"
                                                onChange={(val) => {this.props.actions.changeRoom(val); this.props.actions.loadReservedDays(this.props.House, val); }}
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                {this.props.Rooms.map(room => <Option key={room.name} value={room.name}>{room.shortName}</Option>)}
                                            </Select>
                                        )}
                                    </FormItem>
                                    : null*/}


                                <FormItem {...formItemLayout} label={"Aufgaben"}>
                                </FormItem>
                                {formItems}
                                <FormItem {...formItemLayoutWithOutLabel}>
                                    <Button type="dashed" onClick={this.addToDo} style={{ width: '77%' }}>
                                        <PlusOutlined /> Aufgabe Hinzufügen
                                    </Button>
                                </FormItem>
                            </form>
                        </Col>
                    </Row>
                </Modal>
        );
    }
}



function mapStateToProps(state) {
    const { RoomPlanReducer, Auth } = state;
    const { TodoVisible, Houses, Rooms, Room, actTodoID, actTodoIsRoom, Todo, House } = RoomPlanReducer;
    const { GroupID } = Auth;

    return {
        Houses,
        House,
        Rooms,
        Room,
        TodoVisible,
        actTodoID,
        Todo,
        GroupID,
        actTodoIsRoom
    };
}


function mapDispatchToProps(dispatch) {
    return{
        actions: bindActionCreators(RoomPlanActions, dispatch),
    };
}

const FormTodos = Form.create()(Todos);

export default connect(mapStateToProps, mapDispatchToProps)(FormTodos);
